import { User } from './models/user'
import 'regenerator-runtime/runtime'
import 'core-js/stable'
import './set-public-path'
import { UserHelper, UserHelperEvents } from './utils/userHelper'
import { UserActionTypes, UserAction } from './models/userAction'
import { MenuItemsCodeEnum } from './models/menu'
import { LayoutActivityType, ModalsType } from './models/layout'
import { EventsType } from './models/events-type'
import { I18n } from './models/i18n'
import { PortalsCode } from './models/portals'
import {
    CommentType,
    CommentsAttachment,
    CreateMessageBody,
    ForumMessage,
    ForumUser,
    GetMessageParams,
    PaginationParams,
    UploadFileType,
} from './models/comments'
import {
    IntlProviderWrapper,
    IntlContext,
} from './utils/localization/intlProviderWrapper'
import { i18nSupportedLanguages } from './utils/localization/i18nHelper'
import { LocalStorage } from './utils/localstorage'
import history from './utils/history'
import { Analytics } from './utils/analytics'
import { Logger } from './utils/logger'
import {
    NotificationsApi,
    NotificationSourceModule,
} from './api/notificationsApi'

import packageJson from '../package.json'
Logger._packageInfo(
    packageJson.name,
    packageJson.version,
    process.env.REACT_APP_ENV,
    process.env.NODE_ENV,
    'lightseagreen',
    'black'
)

/**
 * Exports the @param {http} - It's an http client, based on the axios library and needed as a common instance for all the microfrontends
 */
export { http } from './http/http'

/**
 * Exports
 * @param {UserHelper} UserHelper - It's a singleton used to manage the authenticate user data and needed as a common instance for all the microfrontends
 * @param {UserHelperEvents} UserHelperEvents - It's an enum to describe singleton events (triggered when an api call is performed and the redux store gets changed)
 */
export { UserHelper, UserHelperEvents, history }

/**
 * Exports
 * @param {IntlProviderWrapper} IntlProviderWrapper - It's a provider needed by shared modules like navbars and sidebars to perform their localizations
 * @param {useIntlState} useIntlState - The actual state of the Localization Context
 * @param {useIntlDispatch} useIntlDispatch - The actual dispatch to trigger language changes
 * @param {supportedLanguage} supportedLanguage - The actual array of supported languages
 */
export {
    IntlProviderWrapper,
    IntlContext,
    i18nSupportedLanguages as supportedLanguages,
}

export { LocalStorage }
export { User, UserActionTypes, UserAction, I18n, PortalsCode }
export {
    CommentType,
    CommentsAttachment,
    CreateMessageBody,
    ForumMessage,
    ForumUser,
    GetMessageParams,
    PaginationParams,
    UploadFileType,
}
export { LayoutActivityType, ModalsType }
export {
    userReducer,
    loadingReducer,
    successReducer,
    errorsReducer,
    messageReducer,
    permissionsReducer,
    layoutReducer,
    commentsReducer,
} from './redux/reducers'
export { sharedReducers } from './redux/store'
export const sharedStore = UserHelper._shared().store
export {
    errorsActions,
    messageActions,
    successActions,
    permissionsActions,
    layoutActions,
    filtersActions,
    commentsActions,
    userActions,
} from './redux/actions'
export {
    errorsSelectors,
    messageSelectors,
    successSelectors,
    loadingSelectors,
    layoutSelectors,
} from './redux/selectors'
export { UserDispatchTypes, UserDispatcher } from './redux/dispatchers'

export { ability } from './utils/permissions/ability'
export { AbilityContext, Can } from './utils/permissions/can'

export * as commonFunctions from './utils/commonFunctions'
export * as commentsAdapter from './utils/comments-adapter'
export { Analytics, Logger }

export { NotificationsApi, NotificationSourceModule }
export { MenuItemsCodeEnum }
export { EventsType }

export {
    SmartlyActionTypes,
    SmartlyActionItems,
    SmartlyActionSubtypes,
} from './models/permissions'
export { Album } from './models/photos'

import { init as initApm } from '@elastic/apm-rum'

export const apm = initApm({
    serviceName: 'smartly-root-mfe', // Set APM Server URL

    serverUrl: process.env.APM_SERVER_URL, // Set the service version (required for source map feature)

    serviceVersion: '1.0', // Set the service environment

    environment: process.env.REACT_APP_ENV,
    // logLevel: 'debug',
    disableInstrumentations: JSON.parse(
        process.env.APM_DISABLE_INSTRUMENTATIONS
    ),
    //   distributedTracing: true,
    //   distributedTracingOrigins: [BACKEND_ENDPOINT],
    flushInterval: 100,
})

/**
 * This @listens listener is triggered whenever the route changes by listening the @event single-spa:routing-event.
 * This is the entry point of the web application and serves the authentication flow by catching the tokens from the query string
 * If the @param {string} accessToken and @param {string} refreshToken get validated, the anonymous callback process the internal authentication flow
 */

const isValidUrl = (string) => {
    try {
        new URL(string)
        return true
    } catch (err) {
        return false
    }
}

const eventCallback = () => {
    const path = window.location.pathname
    const urlParams = new URLSearchParams(window.location.search)
    const accessTokenParam = urlParams.get('jwt')
    const mode = urlParams.get('mode')
    // const refreshTokenParam = urlParams.get("refreshToken");
    // console.log('DIGITALPORTAL SHARED ROUTIN EVENT', accessTokenParam, path)

    if (accessTokenParam) {
        let accessToken = accessTokenParam
        let refreshToken = accessToken
        if (accessToken && refreshToken) {
            // console.log('PROVO A FARE LOGIN')
            UserHelper._shared().doLogin(accessToken, refreshToken, mode)
        }
    } else if (mode === 'app') {
        // console.log("PROVO A FARE LOGIN DALL'APP")
        // auto-login in app
        let setTokenFromApp = function (evt: any) {
            // console.log('setTokenFromApp')
            if (evt && evt.detail && evt.detail.token) {
                // console.log("L'APP HA RISPOSTO CON IL TOKEN", evt.detail.token)
                UserHelper._shared().doLogin(
                    evt.detail.token,
                    evt.detail.token,
                    mode
                )
            } else {
                const url = new URL(process.env.DIGITAL_PORTAL_URL)
                if (isValidUrl(url)) {
                    location.assign(url.href)
                    // window.location.href = url.href
                }
            }
            window.removeEventListener('getToken', setTokenFromApp)
        }
        window.addEventListener('getToken', setTokenFromApp)
        ;(window as any).webkit?.messageHandlers?.getToken?.postMessage(
            'getToken'
        )
    } else if (path === '/logout') {
        UserHelper._shared().doLogout()
    } else if (path.includes('/login_error') || path.includes('/iframe')) {
        return
    } else {
        if (UserHelper._shared().accessToken() && !path.includes('/iframe')) {
            if (!UserHelper._shared().appPermissions()) {
                UserHelper._shared().getAppPermissions()
            }

            // if (window.location.hostname.includes('smartly')) {
            //     const user: User = UserHelper._shared().user()
            //     UserHelper._shared().getSmartlyPermissions(user)
            // }

            if (path === '/redirect') {
                UserHelper._shared().goToDefaultApp()
            }
        }
    }
}
window.addEventListener('single-spa:routing-event', eventCallback, true)

export const isProd = () => process.env.NODE_ENV === 'production'
export const store360URL = process.env.STORE_360_URL
export const wholesaleURL = process.env.WHOLESALE_URL
export const smartlyURL = process.env.SMARTLY_URL
export const digitalportalURL = process.env.DIGITAL_PORTAL_URL

//ABILITY PERMISSIONS EXPORT SIMPLIFIED

export * from './abilityExport'
